import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface FeatureFlags {
  showWineryWines: boolean;
  showExperiences: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  showWineryWines: false,
  showExperiences: false
};

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/config/feature-flags`;
  private readonly flagsSignal = signal<FeatureFlags>(DEFAULT_FLAGS);
  private loadPromise: Promise<FeatureFlags> | null = null;

  readonly flags = computed(() => this.flagsSignal());

  async loadFlags(): Promise<FeatureFlags> {
    if (!this.loadPromise) {
      this.loadPromise = firstValueFrom(this.http.get<Partial<FeatureFlags>>(this.baseUrl))
        .then((response) => {
          const merged: FeatureFlags = {
            ...DEFAULT_FLAGS,
            ...(response ?? {})
          };
          this.flagsSignal.set(merged);
          return merged;
        })
        .catch(() => {
          // Keep existing flags (defaults) on failure and allow re-tries.
          this.loadPromise = null;
          return this.flagsSignal();
        });
    }

    return this.loadPromise;
  }

  snapshot(): FeatureFlags {
    return this.flagsSignal();
  }
}
